module.exports = __webpack_public_path__ + "static/media/screeenshot_aerobots-vr.d0b9bc50.png";